import { Component, Input } from '@angular/core';

@Component({
  selector: 'error-alert',
  template: require('./error-alert.component.html')
})
export class ErrorAlertComponent {
  @Input()
  public error: Parse.Error;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/display/error-alert/error-alert.component.ts